<span style="margin-right: 10px;"><strong>Assigned to Portfolio:</strong></span>
<div style="display: inline-block;">
    <strong>
        <a (click)="showEditPortfolio()" class="viewPortfolios">{{portfolioTarget.name}}</a>
<!--        <div #doNotViewPortfolio *ngIf="isModified" tooltip [tooltipPosition]="'bottom'" [tooltipTitle]="'Please save changes'" class="viewPortfolios">{{portfolioTarget.name}}</div>-->
    </strong>
</div>
